import { render, staticRenderFns } from "./PayinDetailOrderlistForTest.vue?vue&type=template&id=4ca1aeb4&scoped=true"
import script from "./PayinDetailOrderlistForTest.vue?vue&type=script&lang=js"
export * from "./PayinDetailOrderlistForTest.vue?vue&type=script&lang=js"
import style0 from "./PayinDetailOrderlistForTest.vue?vue&type=style&index=0&id=4ca1aeb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca1aeb4",
  null
  
)

export default component.exports